import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Artikel } from '../entities/artikel.entity';
import { BeigabenArtikel } from '../entities/produkte/beigabenartikel.entity';
import { BeigabenAusloeser } from '../entities/produkte/beigabenausloeser.entity';
//#endregion

@Injectable()
export class BeigabenAusloeserService extends ODataEntityService<BeigabenAusloeser> {
  constructor(protected client: ODataClient) {
    super(client, 'BeigabenAusloeser', 'entities.produkte.BeigabenAusloeser');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public artikel(entity: EntityKey<BeigabenAusloeser>): ODataNavigationPropertyResource<Artikel> {
    return this.entity(entity).navigationProperty<Artikel>('artikel');
  }
  public beigabenArtikel(entity: EntityKey<BeigabenAusloeser>): ODataNavigationPropertyResource<BeigabenArtikel> {
    return this.entity(entity).navigationProperty<BeigabenArtikel>('beigabenArtikel');
  }
  //#endregion
}
